<style lang="scss" src='./Notifications.scss' scoped></style>
<template src="./Notifications.html"></template>

<script>
import {
  mapState,
  mapActions,
  mapGetters,
} from 'vuex';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(['user']),
    ...mapState('Settings', ['notifications']),
    ...mapGetters('Settings', ['getEmailNotifications', 'getPushNotifications']),
  },
  methods: {
    ...mapActions('Settings', ['apiGetNotifications', 'apiChangeStatus']),
  },
  mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Settings Notifications");
      this.$analytics.logEvent("web_settings_notifications");
    }

    this.apiGetNotifications(this.user.user_id);
  },
};
</script>
